(() => {
  const root = document.documentElement;

  if (root?.getAttribute('data-sunco-navigation-guard-loaded') === 'true') return;
  root?.setAttribute('data-sunco-navigation-guard-loaded', 'true');

  const isModifiedClick = (event) =>
    event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (typeof event.button === 'number' && event.button !== 0);

  const interactiveSelector = [
    'form',
    'button',
    '[role="button"]',
    'details',
    'summary',
    'dialog',
    'modal-dialog',
    'cart-drawer',
    'quick-add-modal',
    'product-form',
    'variant-picker',
    '[data-cart-drawer]',
    '[data-sunco-compare-bar]',
    '[data-sunco-compare-control]',
    '[data-sunco-grouped-addon]',
    '[data-sunco-mobile-quick-add]',
    '[data-sunco-product-variant]',
  ].join(',');

  const getNavigableInternalLink = (event) => {
    if (event.defaultPrevented || isModifiedClick(event)) return null;
    if (window.Shopify?.designMode) return null;

    const link = event.target?.closest?.('a[href]');
    if (!link || link.hasAttribute('download')) return null;
    if (link.closest(interactiveSelector)) return null;

    const target = (link.getAttribute('target') || '').toLowerCase();
    if (target && target !== '_self') return null;

    const href = link.getAttribute('href') || '';
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('sms:')
    ) {
      return null;
    }

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_error) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;

    const samePageHash = url.pathname === window.location.pathname && url.search === window.location.search && url.hash;
    if (samePageHash) return null;

    return link;
  };

  const navigateWhilePendingLoads = (event) => {
    if (document.readyState === 'complete') return;

    const link = getNavigableInternalLink(event);
    if (!link) return;

    const destination = link.href;
    event.preventDefault();
    window.stop();

    window.setTimeout(() => {
      window.location.assign(destination);
    }, 0);
  };

  document.addEventListener('click', navigateWhilePendingLoads, { capture: true });
})();
